import { CSSObject } from '@emotion/react';

const wrap = (): CSSObject => ({
  background: '#fff',
  borderRadius: '12px',
  minWidth: '300px',
});

const content: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  whiteSpace: 'pre-line',
  padding: '40px 20px 16px 20px',
  fontSize: '16px',
  lineHeight: '1.4',
  textAlign: 'center',
};

const buttonArea = (): CSSObject => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '16px 20px',
  gap: '8px',

  '& > button': {
    position: 'relative',
    flex: 1,
    height: '48px',
    fontWeight: 500,
    fontSize: '16px',
    textAlign: 'center',
    background: '#0C0C0C',
    border: '1px solid #0C0C0C',
    borderRadius: '10px',
    color: '#fff',
  },

  '& > button:nth-of-type(2)': {
    background: '#fff',
    border: '1px solid #DCDDDF',
    color: '#0C0C0C',
  },
});

export { wrap, content, buttonArea };
